import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
} from '@mui/material';
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import emailjs from 'emailjs-com';
import logo from '../assets/logo.jpg';

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    servicio: '',
    mensaje: '',
  });

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  // ---------------------------------------------
  // FUNCIÓN PARA ENVIAR CORREO con EmailJS
  // ---------------------------------------------
  const handleSubmit = (event) => {
    event.preventDefault();

    const templateParams = {
      nombre: formData.nombre,
      telefono: formData.telefono,
      email: formData.email,
      servicio: formData.servicio,
      mensaje: formData.mensaje,
    };

    emailjs
      .send(
        'service_qc54m7a',     // ✔ Tu Service ID
        'template_8zodr4x',     // ✔ Tu Template ID
        templateParams,
        'flhuKAu3cDjqx1tIw'     // ✔ Tu Public Key
      )
      .then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Gracias, hemos recibido tu mensaje 🤍');
          setFormData({
            nombre: '',
            telefono: '',
            email: '',
            servicio: '',
            mensaje: '',
          });
        },
        (error) => {
          console.error('FAILED...', error);
          alert('Ocurrió un error al enviar el mensaje. Intenta más tarde.');
        }
      );
  };

  // ---------------------------------------------

  return (
    <Box sx={{ backgroundColor: '#ffffff' }}>
      {/* HEADER NEGRO */}
      <Box
        sx={{
          backgroundColor: '#000000',
          color: '#ffffff',
          py: 6,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            sx={{
              fontFamily: 'Outfit, var(--title-font)',
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '2.6rem' },
              textAlign: 'center',
              letterSpacing: 2,
            }}
          >
            CONTACTO
          </Typography>
        </Container>
      </Box>

      {/* CONTENEDOR DOS COLUMNAS */}
      <Box sx={{ py: 8 }}>
        <Container maxWidth="lg">
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 6,
              alignItems: { xs: 'flex-start', md: 'flex-start' },
            }}
          >
            {/* IZQUIERDA: INFO CONTACTO */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              {/* LOGO */}
              <Box sx={{ mb: 4 }}>
                <img
                  src={logo}
                  alt="D3 Producciones Logo"
                  style={{
                    width: 160,
                    height: 160,
                    objectFit: 'contain',
                    display: 'block',
                  }}
                />
              </Box>

              {/* WHATSAPP */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <FaWhatsapp size={22} color="#a9ce49" />
                <Typography
                  sx={{
                    fontFamily: 'Poppins, var(--text-font)',
                    fontSize: 15,
                    color: '#111827',
                  }}
                >
                  <strong>WhatsApp:</strong> +52 55 3110 0884
                </Typography>
              </Box>

              {/* TELÉFONO */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <FaPhoneAlt size={20} color="#3c77b6" />
                <Typography
                  sx={{
                    fontFamily: 'Poppins, var(--text-font)',
                    fontSize: 15,
                    color: '#111827',
                  }}
                >
                  <strong>Teléfono:</strong> +52 55 5006 1974
                </Typography>
              </Box>

              {/* CORREO */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <FaEnvelope size={20} color="#a9ce49" />
                <Typography
                  sx={{
                    fontFamily: 'Poppins, var(--text-font)',
                    fontSize: 15,
                    color: '#111827',
                  }}
                >
                  <strong>Correo:</strong> daltruji@hotmail.com
                </Typography>
              </Box>

              {/* UBICACIÓN */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <FaMapMarkerAlt size={22} color="#3c77b6" />
                <Typography
                  sx={{
                    fontFamily: 'Poppins, var(--text-font)',
                    fontSize: 15,
                    color: '#111827',
                  }}
                >
                  <strong>Ubicación:</strong> Ciudad de México
                </Typography>
              </Box>
            </Box>

            {/* DERECHA: FORMULARIO */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
              }}
            >
              {/* TÍTULO + LÍNEAS */}
              <Box sx={{ mb: 3, textAlign: 'center' }}>
                <Typography
                  variant="h5"
                  sx={{
                    fontFamily: 'Outfit, var(--title-font)',
                    fontWeight: 700,
                    fontSize: { xs: '1.4rem', md: '1.7rem' },
                    letterSpacing: 1,
                    textTransform: 'uppercase',
                    mb: 1,
                  }}
                >
                  FORMULARIO DE CONTACTO
                </Typography>

                <Box sx={{ mx: 'auto', width: 'fit-content' }}>
                  <Box
                    sx={{
                      width: 130,
                      height: 3,
                      backgroundColor: '#a9ce49',
                      mb: '1px',
                    }}
                  />
                  <Box
                    sx={{
                      width: 130,
                      height: 3,
                      backgroundColor: '#3c77b6',
                    }}
                  />
                </Box>
              </Box>

              {/* DESCRIPCIÓN */}
              <Typography
                sx={{
                  fontFamily: 'Poppins, var(--text-font)',
                  fontSize: 14.5,
                  lineHeight: 1.6,
                  color: '#4b5563',
                  textAlign: 'center',
                  mb: 3,
                }}
              >
                Completa el formulario y nos pondremos en contacto contigo pronto.
              </Typography>

              {/* FORMULARIO */}
              <Box
                sx={{
                  backgroundColor: '#3c77b6',
                  borderRadius: 2,
                  p: 3,
                  boxShadow: '0 16px 35px rgba(0,0,0,0.18)',
                }}
              >
                <form onSubmit={handleSubmit}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                    <TextField
                      label="Nombre"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={formData.nombre}
                      onChange={handleChange('nombre')}
                      InputProps={{ style: { backgroundColor: '#ffffff' } }}
                    />

                    <TextField
                      label="Teléfono"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={formData.telefono}
                      onChange={handleChange('telefono')}
                      InputProps={{ style: { backgroundColor: '#ffffff' } }}
                    />

                    <TextField
                      label="Email"
                      type="email"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={formData.email}
                      onChange={handleChange('email')}
                      InputProps={{ style: { backgroundColor: '#ffffff' } }}
                    />

                    <TextField
                      label="Servicio de interés"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={formData.servicio}
                      onChange={handleChange('servicio')}
                      InputProps={{ style: { backgroundColor: '#ffffff' } }}
                    />

                    <TextField
                      label="Cuéntanos más de tu idea"
                      multiline
                      rows={4}
                      variant="outlined"
                      fullWidth
                      value={formData.mensaje}
                      onChange={handleChange('mensaje')}
                      InputProps={{ style: { backgroundColor: '#ffffff' } }}
                    />

                    <Box sx={{ textAlign: 'right', mt: 1 }}>
                      <Button
                        type="submit"
                        sx={{
                          textTransform: 'none',
                          fontFamily: 'Poppins, var(--text-font)',
                          fontWeight: 600,
                          fontSize: 15,
                          borderRadius: '4px',
                          px: 3,
                          py: 1,
                          backgroundColor: '#ffffff',
                          color: '#111827',
                          '&:hover': {
                            backgroundColor: '#e5e7eb',
                          },
                        }}
                      >
                        Enviar
                      </Button>
                    </Box>
                  </Box>
                </form>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Contacto;
